import React, { useMemo, useState } from "react";
import plusIcon from "../../assets/icons/plus-icon.png";

import "./table.css";
export default function Table({
  columns,
  data,
  onDelete,
  onEdit,
  onAddClick,
  title,
  maxRow,
}) {
  const [search, setSearch] = useState("");
  const [itemPerPage, setItemPerPage] = useState(10);
  const [showItemPerPage, setShowItemPerPage] = useState(false);

  const [startPage, setStartPage] = useState(1);
  const [endPage, setEndPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const image_url = process.env.REACT_APP_Image_APP_URL;
  // 🔍 Filtering
  const filteredData = useMemo(() => {
    if (!search) return data;

    let result = data.filter((row) =>
      columns.some((col) => {
        let value;

        // 👇 use render output if exists
        if (col.render) {
          value = col.render(row, {});
        } else {
          value = row[col.accessor];
        }

        if (value === null || value === undefined) return false;

        return (
          value && value.toString().toLowerCase().includes(search.toLowerCase())
        );
      }),
    );
    if (result) {
      setStartPage(1);
      setEndPage(result.length > itemPerPage ? itemPerPage : result.length);
    }
    return result;
  }, [search, data, columns]);

  // ↕️ Sorting
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;
    return [...filteredData].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortConfig]);
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const handleChangeItemsPerPage = (value) => {
    setItemPerPage(value);
    setShowItemPerPage(false);
    setStartPage(1);
    setEndPage(sortedData.length > value ? value : sortedData.length);
  };
  const handleNextPagesCLick = () => {
    setStartPage(sortedData.length > endPage ? endPage + 1 : startPage);
    setEndPage(
      sortedData.length > endPage + itemPerPage
        ? endPage + itemPerPage
        : sortedData.length,
    );
  };
  const hanldeChangeSearch = (e) => {
    setSearch(e.target.value);
  };
  const handleBackPagesCLick = () => {
    setStartPage(startPage - itemPerPage > 1 ? startPage - itemPerPage : 1);
    setEndPage(startPage - itemPerPage > 0 ? startPage - 1 : endPage);
  };

  return (
    <div className="card  mt-4 ">
      <div className="card-header">
        <div className="row d-flex align-items-center">
          <div className="col-7 d-flex align-items-center">
            <h5 className="mb-0 title me-3">{title}</h5>
            <div className="input-group searchInput w-50">
              <span className="input-group-text">
                <i className="fa-solid fa-magnifying-glass"></i>
              </span>
              <input
                className="text"
                className="form-control search-text"
                placeholder="Search..."
                onChange={hanldeChangeSearch}
              />
            </div>
          </div>
          <div className="col-5  d-flex justify-content-end j p-2">
            <button
              className="btn btn-primary ms-3"
              onClick={onAddClick}
              disabled={maxRow && maxRow <= data.length}
            >
              <img src={plusIcon} alt="" />
            </button>
            <button
              className="btn btn-transparent ms-3"
              onClick={onAddClick}
              disabled={maxRow && maxRow <= data.length}
            >
              <i
                className="fa-solid fa-filter"
                style={{ color: " rgb(177, 151, 252)" }}
              ></i>{" "}
            </button>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th
                  className="ps-3"
                  key={index}
                  onClick={() => col.accessor && handleSort(col.accessor)}
                  style={{ cursor: col.accessor ? "pointer" : "default" }}
                >
                  {col.header}
                  {sortConfig.key === col.accessor && (
                    <span className="ms-1">
                      {sortConfig.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {sortedData.length > 0 ? (
              sortedData.slice(startPage - 1, endPage).map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => {
                    const value = row[col.accessor];
                    return (
                      <td key={colIndex} className="ps-3">
                        {col.render ? (
                          col.render(row, { onEdit, onDelete })
                        ) : typeof value === "string" &&
                          (value.toLowerCase().includes("jpeg") ||
                            value.toLowerCase().includes("jpg")) ? (
                          <img
                            src={`${image_url}${value}`}
                            alt="preview"
                            className="img-thumbnail"
                            style={{ maxWidth: "150px", maxHeight: "150px" }}
                          />
                        ) : (
                          value
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="card-footer d-flex justify-content-end">
        <div className="d-flex align-items-center me-2">Items per page</div>
        <div className="dropup-center dropup">
          <button
            className="btn btn-outline-dark dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setShowItemPerPage(!showItemPerPage)}
          >
            {itemPerPage}
          </button>
          <ul className={`dropdown-menu ${showItemPerPage ? "show" : ""}`}>
            <li>
              <a
                className="dropdown-item"
                onClick={() => {
                  handleChangeItemsPerPage(10);
                }}
              >
                10
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                onClick={() => {
                  handleChangeItemsPerPage(25);
                }}
              >
                25
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                onClick={() => {
                  handleChangeItemsPerPage(100);
                }}
              >
                100
              </a>
            </li>
          </ul>
        </div>
        <div className="d-flex align-items-center me-3 ms-3">
          {startPage} -{" "}
          {endPage > sortedData.length ? sortedData.length : endPage} of{" "}
          {sortedData.length}
        </div>
        <button
          className="nextPageButton btn rounded-circle"
          onClick={() => handleBackPagesCLick()}
          disabled={startPage == 1}
        >
          <i className="fa-solid fa-angle-left"></i>
        </button>

        <button
          className="nextPageButton rounded-circle me-1"
          onClick={() => handleNextPagesCLick()}
        >
          <i className="fa-solid fa-angle-right"></i>
        </button>
      </div>
    </div>
  );
}
